import { useAtom } from "jotai";
import { useEffect } from "react";
import { authAtom } from "../../../atoms/auth.atom";
import { axios } from "../../../api/axios";
import { handleResponse } from "../../../utils/functions/http/handleResponse";
import { useNavigate } from "react-router-dom";

export const Logout = () => {
  const navigate = useNavigate();

  const [auth, setAuth] = useAtom(authAtom);

  useEffect(() => {
    if (auth.loaded && auth.authenticated) {
      axios
        .post("/auth/logout")
        .then((result) =>
          handleResponse(result, () => {
            setAuth({ loaded: true, user: null, authenticated: false });
            navigate("/", { replace: true });
          })
        )
        .catch((err) => {
          handleResponse(err);

          navigate("/", { replace: true });
        });
    }
  }, [auth]);

  return <></>;
};
